module.exports = __webpack_public_path__ + "img/45.09a30a42.png";